import React from 'react';
import Button, { ButtonGroup } from '../../components/bootstrap/Button';

interface IStatus {
	[key: string]: 'Online' | 'Offline';
}

interface UserStatusProps {
	status: 'Online' | 'Offline';
	setStatus: (status: 'Online' | 'Offline') => void;
}

const STATUS: IStatus = {
	ONLINE: 'Online',
	OFFLINE: 'Offline',
};

const UserStatus: React.FC<UserStatusProps> = ({ status, setStatus }) => {
	return (
		<ButtonGroup>
			<Button isDisable color='dark' isLight>
				Mode:
			</Button>
			<Button
				icon='AccountCircle'
				color={status === STATUS.ONLINE ? 'info' : 'dark'}
				isLight={status !== STATUS.ONLINE}
				onClick={() => setStatus(STATUS.ONLINE)}
				aria-label={STATUS.ONLINE}
			>Online</Button>
			<Button
				icon='NoAccounts'
				color={status === STATUS.OFFLINE ? 'info' : 'dark'}
				isLight={status !== STATUS.OFFLINE}
				onClick={() => setStatus(STATUS.OFFLINE)}
				aria-label={STATUS.OFFLINE}
			>Offline</Button>
		</ButtonGroup>
	);
};

export default UserStatus;
